/*
  <pricing-tiers> — Web component for the GLP-1 landing page pricing card.

  Responsibilities:
  - Maintain a single selected tier (matches [data-recommended] on load)
  - On tier click: toggle [data-selected] across siblings, append ?plan={tier_id}
    to every [data-glp1-cta] anchor's href, fire GTM events
  - Fire landing_page_view once per real page load (guarded against customizer re-renders)
*/

(function () {
  if (typeof window === 'undefined') return;
  if (customElements.get('pricing-tiers')) return;

  function pushDataLayer(eventObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventObj);
  }

  function appendPlanParam(baseUrl, tierId) {
    if (!tierId) return baseUrl;
    var separator = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    return baseUrl + separator + 'plan=' + encodeURIComponent(tierId);
  }

  function stripPlanParam(href) {
    if (!href) return href;
    return href.replace(/[?&]plan=[^&#]*/g, '');
  }

  customElements.define(
    'pricing-tiers',
    class PricingTiers extends HTMLElement {
      constructor() {
        super();
        this._onTierClick = this._onTierClick.bind(this);
        this._onCtaClick = this._onCtaClick.bind(this);
      }

      connectedCallback() {
        this.tiers = Array.from(this.querySelectorAll('.glp1-pricing-tier'));
        this.ctas = Array.from(document.querySelectorAll('[data-glp1-cta]'));

        this.ctas.forEach(function (cta) {
          if (!cta.hasAttribute('data-href-base')) {
            cta.setAttribute('data-href-base', stripPlanParam(cta.getAttribute('href') || ''));
          }
        });

        var initial = this.tiers.find(function (t) { return t.hasAttribute('data-recommended'); });
        if (!initial) initial = this.tiers[0];
        if (initial) this._setSelectedTier(initial.dataset.tierId, false);

        this.tiers.forEach((tier) => tier.addEventListener('click', this._onTierClick));
        this.ctas.forEach((cta) => cta.addEventListener('click', this._onCtaClick));

        if (!window.__glp1ViewFired) {
          window.__glp1ViewFired = true;
          pushDataLayer({ event: 'landing_page_view' });
        }
      }

      disconnectedCallback() {
        if (this.tiers) {
          this.tiers.forEach((tier) => tier.removeEventListener('click', this._onTierClick));
        }
        if (this.ctas) {
          this.ctas.forEach((cta) => cta.removeEventListener('click', this._onCtaClick));
        }
      }

      _onTierClick(e) {
        var tierId = e.currentTarget.dataset.tierId;
        this._setSelectedTier(tierId, true);
      }

      _setSelectedTier(tierId, fireEvent) {
        if (!tierId) return;
        this.tiers.forEach(function (tier) {
          if (tier.dataset.tierId === tierId) {
            tier.setAttribute('data-selected', '');
            tier.setAttribute('aria-pressed', 'true');
          } else {
            tier.removeAttribute('data-selected');
            tier.setAttribute('aria-pressed', 'false');
          }
        });
        this._updateCtaHrefs(tierId);
        this.currentTierId = tierId;
        window.__glp1CurrentTier = tierId;
        if (fireEvent) {
          pushDataLayer({ event: 'landing_page_pricing_tier_select', tier_id: tierId });
        }
      }

      _updateCtaHrefs(tierId) {
        this.ctas.forEach(function (cta) {
          var base = cta.getAttribute('data-href-base') || '';
          cta.setAttribute('href', appendPlanParam(base, tierId));
        });
      }

      _onCtaClick(e) {
        var cta = e.currentTarget;
        var position = cta.dataset.position || 'unknown';
        pushDataLayer({ event: 'landing_page_cta_click', position: position });
      }
    }
  );
})();
